import { makeStyles } from 'tss-react/mui';

import { collapseClasses } from '@mui/material';

export const useStyles = makeStyles({ name: 'Toc' })({
    root: {
        fontSize: 14,
        lineHeight: '150%',
        letterSpacing: '-0.28px',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        color: '#8E8E8E'
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        fontWeight: 600,
        color: '#232323',
        margin: 0
    },
    link: {
        color: '#8E8E8E',
        textDecoration: 'none',
        fontWeight: 500,
        transition: 'all 0.2s',
        '&:hover': {
            color: '#232323'
        }
    },
    collapse: {
        [`.${collapseClasses.wrapperInner}`]: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    },
    _rotated: {
        transform: 'rotate(180deg)'
    },
    icon: {
        transition: 'transform 0.2s'
    }
});
